/**
 * Eine offene Pflichtmitteilung, wie `core` sie ausliefert.
 *
 * 🔑 **Eine Mitteilung, zwei Ansichten.** Ob der angemeldete Nutzer unterzeichnen darf, entscheidet `canSign` —
 * nicht eine zweite Mitteilung. Wer es nicht darf, bekommt die Hinweisansicht mit `signatories`.
 *
 * ⚠️ **`canSign` ist Bedienkomfort, keine Sperre.** Verbindlich ist die Prüfung am Endpunkt
 * (`hasPermission(#orgId, 'AGREEMENT', 'RW')`); wer die Schnittstelle unmittelbar anspricht, kommt hier nicht vorbei.
 */
export class NoticeDto {

  public readonly id!: string;
  /** `INFO` (zur Kenntnis nehmen) oder `CONSENT` (Dokument annehmen). */
  public readonly type!: string;
  public readonly binding!: string;
  /** Übersetzungsschlüssel der Umrahmung. Der Rechtstext selbst kommt getrennt über `LegalService`. */
  public readonly textKey!: string;
  /** Bei `CONSENT` das anzunehmende Dokument. */
  public readonly agreementType: string | undefined;
  public readonly version: number | undefined;
  public readonly dueDate: string | undefined;
  /** Wird neben der Kenntnisnahme auch der Widerspruch angeboten? */
  public readonly objection!: boolean;
  public readonly canSign!: boolean;
  public readonly signatories: NoticeSignatoryDto[] | undefined;

  constructor(init?: Partial<NoticeDto> | undefined) {
    Object.assign(this, init);
  }
}

/** Der **Name** einer zeichnungsberechtigten Person — ⛔ ohne Adresse, seit `core` die Erinnerung selbst verschickt. */
export class NoticeSignatoryDto {

  public readonly name!: string;

  constructor(init?: Partial<NoticeSignatoryDto> | undefined) {
    Object.assign(this, init);
  }
}

/** `sent = false` heißt: heute wurde bereits erinnert — kein Fehler. */
export class NoticeRemindDto {

  public readonly sent!: boolean;
  public readonly recipients!: number;
  public readonly reminded: string | undefined;

  constructor(init?: Partial<NoticeRemindDto> | undefined) {
    Object.assign(this, init);
  }
}
